import React from 'react';
import { Icon } from '@material-ui/core';

const FontIcon = ({className}) => <i className={`zmdi zmdi-${className}`} />

export { FontIcon };
export default Icon;
